import { request } from '@@/plugin-request';

export async function getSchoolEventNotifications() {
  return request('/api/school/reminder', {
    method: 'get',
  });
}
